<!-- DeliverIt Iframe Overlay -->
<!-- Modal Backdrop -->
<div class="iframe-modal-backdrop"
    *ngIf="showIframe"
    (click)="closeIframe()"></div>

<!-- Iframe Panel -->
<div class="iframe-overlay"
    *ngIf="showIframe">
    <div class="iframe-header">
        <div class="header-brand-container">
            <img src="assets/images/deliverIt.png"
                alt="DeliverIt"
                class="brand-icon"
                onerror="this.style.display='none'">
            <span class="fw-semibold text-muted font-weight-medium">Cart</span>
        </div>
        <div class="d-flex gap-2">
            <button class="iframe-control-btn"
                (click)="reloadIframe()"
                title="Refresh">
                <i class="material-icons">refresh</i>
            </button>
            <button class="iframe-control-btn close-btn"
                (click)="closeIframe()"
                title="Close">
                <i class="material-icons">close</i>
            </button>
        </div>
    </div>
    <div class="iframe-body">
        <iframe #iframeElement
            *ngIf="iframeUrlSafe"
            [src]="iframeUrlSafe"
            class="deliverit-iframe"
            frameborder="0"
            loading="lazy"
            allow="payment; geolocation"></iframe>
    </div>
</div>
